/* eslint-disable react-refresh/only-export-components */
import { HStack, defineStyle, Center, Spinner, Box } from '@chakra-ui/react';
import {
  VideoHangUpIcon,
  VideoFullScreenIcon,
  VoiceJoinIcon,
  VideoIcon,
  VideoIgnoreIcon,
  CallVideoIcon,
  CallUnVideoIcon,
} from '@halo/ui-chat-react';

const connectCss = defineStyle({
  height: '82px',
  bg: 'bg',
  color: 'fg',
});

const unConnectCss = defineStyle({
  height: 'auto',
  bg: 'transparent',
  color: 'white',
  pt: '2.5',
  pb: '4',
});

export enum MediaActionType {
  AUDIO = 1,
  VIDEO = 2,
}

export enum MediaActionStatus {
  CALL = 1,
  CALLEE = 2,
}

export interface CallMinActionsProps {
  videoState?: boolean;
  mediaType: MediaActionType;
  status?: MediaActionStatus;
  isConnect?: boolean;
  multiplayer?: boolean;
  setZoom?: (bol: boolean) => void;
  onHangup?: () => void;
  onAccept?: (actionType: MediaActionType) => void;
  onDecline?: () => void;
  onEnableDevice?: () => void;
}

export function CallMinActions({
  videoState,
  status,
  isConnect,
  mediaType,
  multiplayer,
  setZoom,
  onHangup,
  onAccept,
  onDecline,
  onEnableDevice,
}: CallMinActionsProps) {
  const [loading, setLoading] = useState(false);

  const fullScreen = useMemo(() => {
    return (
      <>
        <Box
          h="9"
          cursor="pointer"
          _active={{ opacity: 0.7 }}
          onClick={() => {
            if (setZoom) setZoom?.(true);
          }}
        >
          <VideoFullScreenIcon />
        </Box>
        {mediaType === MediaActionType.VIDEO && (
          <>
            {videoState ? (
              <Box
                h="9"
                cursor="pointer"
                _active={{ opacity: 0.7 }}
                onClick={() => {
                  onEnableDevice?.();
                }}
              >
                <CallVideoIcon width="100%" height="100%" />
              </Box>
            ) : (
              <Box
                h="9"
                cursor="pointer"
                _active={{ opacity: 0.7 }}
                onClick={() => {
                  onEnableDevice?.();
                }}
              >
                <CallUnVideoIcon width="100%" height="100%" />
              </Box>
            )}
          </>
        )}
      </>
    );
  }, [mediaType, onEnableDevice, setZoom, videoState]);

  const IconRight = useMemo(() => {
    switch (status) {
      case MediaActionStatus.CALL:
        return fullScreen;
      case MediaActionStatus.CALLEE:
        return (
          <>
            <Box
              cursor="pointer"
              _active={{ opacity: 0.7 }}
              onClick={() => {
                onAccept?.(MediaActionType.AUDIO);
                setLoading(true);
              }}
            >
              <VoiceJoinIcon />
            </Box>
            {mediaType === MediaActionType.VIDEO && (
              <Box
                cursor="pointer"
                _active={{ opacity: 0.7 }}
                onClick={() => {
                  onAccept?.(MediaActionType.VIDEO);
                  setLoading(true);
                }}
              >
                <VideoIcon />
              </Box>
            )}
          </>
        );
      default:
        return fullScreen;
    }
  }, [status, fullScreen, onAccept, mediaType]);
  return (
    <HStack
      pos="absolute"
      bottom="0"
      left="0"
      px="2.5"
      justify="center"
      fontSize="xs"
      fontWeight="medium"
      w="full"
      css={{
        ...(isConnect ? connectCss : unConnectCss),
      }}
    >
      <HStack
        gap={mediaType === MediaActionType.VIDEO && !isConnect ? '4.5' : '10'}
        w="full"
        justify="center"
        alignItems="center"
      >
        {loading ? (
          <Center py={13}>
            <Spinner color="white" size="lg" />
          </Center>
        ) : (
          <>
            {isConnect ? (
              <Box cursor="pointer" _active={{ opacity: 0.7 }} onClick={() => setZoom?.(true)}>
                <VideoFullScreenIcon />
              </Box>
            ) : (
              IconRight
            )}
            <Box
              cursor="pointer"
              _active={{ opacity: 0.7 }}
              onClick={() => {
                if (status === MediaActionStatus.CALLEE) {
                  onDecline?.();
                } else {
                  onHangup?.();
                }
              }}
            >
              {!isConnect && multiplayer ? <VideoIgnoreIcon /> : <VideoHangUpIcon />}
            </Box>
          </>
        )}
      </HStack>
    </HStack>
  );
}

export default memo(CallMinActions);
